module.exports = __webpack_public_path__ + "img/powered-by-dark.d438f8b4.svg";